import React from "react";
import "./Team.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn, faInstagram } from "@fortawesome/free-brands-svg-icons";

const SocialButtons = ({ links }) => {
  const getIcon = (iconName) => {
    switch (iconName) {
      case "linkedin":
        return faLinkedinIn;
      case "Instagram":
        return faInstagram;
      default:
        return null;
    }
  };

  return (
    <div className="social-links">
      {links.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <FontAwesomeIcon icon={getIcon(link.icon)} />
        </a>
      ))}
    </div>
  );
};

export default SocialButtons;